import { render } from "./MyIspirazioni.vue?vue&type=template&id=21cdeaae&scoped=true"
import script from "./MyIspirazioni.vue?vue&type=script&lang=js"
export * from "./MyIspirazioni.vue?vue&type=script&lang=js"

import "./MyIspirazioni.vue?vue&type=style&index=0&id=21cdeaae&scoped=true&lang=css"
import "./MyIspirazioni.vue?vue&type=style&index=1&id=21cdeaae&lang=css"

import exportComponent from "/Users/mattia/Desktop/Projects/elbi-website-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21cdeaae"]])

export default __exports__